window.Popper = require('popper.js');
window.Tether = require('tether');
require('bootstrap');

require('fancybox');

require('./parts/owl_carousels');
require('./parts/smooth_scroll');
// require('./parts/count_down');
require('./parts/video');
require('./parts/forms');

require('./parts/icons');



// WEBPACK FOOTER //
// ./js/app.js